import epsClientV1 from '../eps-v1.client'

export default epsClientV1
